export const without_credit_projects = ["duo"];
